var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElement2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 119.76 86.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#040505;}.cls-4{fill:#e02825;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#d8006c;}.cls-7{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -77.31,
    y: -68.23,
    width: 257.81,
    height: 235.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -31.96,
    y: -54.76,
    width: 167.04,
    height: 208.83,
    transform: "translate(-14.39 77.48) rotate(-66.79)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    className: "cls-3",
    d: "M79,43.21c-7.5,19.63-26.5,34.63-48.8,27.57-1.51-.08-3.15-.28-4.78-.45s-3.29-.37-4.91-.49a20.07,20.07,0,0,1,1-4.91,41.59,41.59,0,0,1,1.89-4.58c9.14-12.51,16.14-29.51,32-35.93a25.75,25.75,0,0,1,4.06-2.22c5.85-2.61,12.1-3.86,19.1-1.36,8,3,9,13,3.55,18.91A31.2,31.2,0,0,1,79,43.21M87.85,20a36.14,36.14,0,0,0-34.52.1,32.13,32.13,0,0,0-4.9,3.14c-12,7.56-20,19.56-26.86,31.89-.9,1.77-1.7,3.38-2.34,4.94-1.93,4.61-2.4,8.73.23,11.73,3,3.38,7.54,4.92,12.77,5.38a44.59,44.59,0,0,0,5.42.13c17.8-.51,34.8-5.51,39.95-25,1.14-1.84,2.3-3.57,3.43-5.28,4.52-6.86,8.62-14,8.81-22.63a7.66,7.66,0,0,0-2-4.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    className: "cls-4",
    d: "M82.79,24.47a34.66,34.66,0,0,0-22.71-1.85,24.81,24.81,0,0,0-5,1.86C39.45,31.84,29.45,45.84,24.38,62.25a39,39,0,0,1-1.79,4.52c-.67,1.39-1.37,2.75-2.14,4.07,1.63.25,3.25.46,4.88.65s3.21.31,4.74.34c22.38,4,39.38-7,46.43-27.88.91-1.72,1.85-3.3,2.8-4.86,1.9-3.13,3.83-6.34,5.72-9.7.35-2.52-.23-4.4-2.24-4.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    className: "cls-3",
    d: "M60.06,32.06c-14.6,1.78-22.6,17.78-26.6,30.78,5-9,9-18,16-25,4-4,11-6,14,0,2,4,1,7,0,11-6,12-18,14-30,14,6-1,13,4,18,0,9-6,23-17,13.53-29.41a21.61,21.61,0,0,0-4.93-1.37"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    className: "cls-6",
    d: "M60.34,30.08C44.46,32.84,33.46,47.84,30.46,62.84c9-13,23-42,37-26,6,7-7,18-14,26,8-8,21-17,16-31a12.9,12.9,0,0,1-3.7-.6,31.32,31.32,0,0,0-5.42-1.16"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    className: "cls-3",
    d: "M58.45,26.11c-16,5.73-29,21.73-31,38.73,8-16,17-36,37.36-36.63a19.08,19.08,0,0,1,5.28,1,23.92,23.92,0,0,1,5.36,2.6,23.75,23.75,0,0,0-2.69,4.1c-6.31,19.9-23.31,35.9-45.31,29.9,21,8,42-3,47.39-25.12a53.58,53.58,0,0,1,2.69-5.22c1-1.6,1.92-3.16,2.92-4.66a84.74,84.74,0,0,1-12.8-3.5c-1.45-.48-3-1-4.54-1.47a21.37,21.37,0,0,0-4.66.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    className: "cls-6",
    d: "M60.38,34.15C49.45,36.84,33.45,49.84,41.45,59.84c6,7,18-6,23-15,1-3,0-7-2.4-10.2a4.47,4.47,0,0,0-1.68-.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    className: "cls-6",
    d: "M63.76,11.62a22.57,22.57,0,0,0-5.44,2.68,34.55,34.55,0,0,1-8.09,4.89l-4.15,2.49c-1.37.82-2.73,1.64-4,2.43C32.46,28.84,23.46,35.84,21.61,47c-.84,1.8-1.72,3.51-2.6,5.23-4.38,8.53-8.68,16.89-5.55,25.64a96.16,96.16,0,0,1,6-17c.82-1.82,1.69-3.62,2.59-5.57,6.37-13.47,15.37-24.47,28.13-32.38A37.94,37.94,0,0,1,55,20.35,43.54,43.54,0,0,1,86.33,18.2c2.1.42,4,1.3,6.15,1.26A7.8,7.8,0,0,0,90.08,24c-2.31,7.91-6,15.36-9.81,22.69-1,1.84-1.94,3.69-2.93,5.66-4.88,18.47-21.88,22.47-39.25,23-1.75.14-3.55.26-5.45.34a77.65,77.65,0,0,0-17.18,2.1c8.75,0,17.89,1.17,26.83,1.22,1.78,0,3.5,0,5.22-.12,3-.1,7-.1,10.33-1.43,1.86-.11,3.65-.21,5.38-.28L68.41,77a6.68,6.68,0,0,0,7.27-4.76c.75-1.52,1.5-3,2.22-4.52,4.56-11.89,13.56-22.89,17.85-35,.67-1.58,1.37-3,2.07-4.39q2.12-4.18,4.12-8.42a3.32,3.32,0,0,0,.47-2c-.43-2.21-11.88-3.12-14-3.53-5.35-1-10.7-2-16.07-2.88-3-.49-5.62.09-8.57.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    className: "cls-6",
    d: "M70.05.87a11.84,11.84,0,0,0-1.88.28c-3,.73-5.39,3-8,4.48-4.22,2.45-8.47,4.84-12.71,7.25L22,27.35A9.54,9.54,0,0,0,20,28.79c-1.91,1.89-2.5,5.39-3.5,7.82-.64,1.53-1.25,3-1.78,4.49-2.22,7.74-6.22,14.74-9.23,23-.6,1.72-1.2,3.28-1.81,4.84s-1.21,3.09-1.82,4.63c-1,2.49-1.94,5.41-.6,7.72a2.69,2.69,0,0,0,3.11,1.42c2-.84,2.5-4.14,3.15-5.87.57-1.53,1-3.4,1.47-5.25,3.51-12.8,10.51-24.8,16.78-37.93a31.86,31.86,0,0,1,3.45-3.52A73.53,73.53,0,0,1,41.59,22L63.45,9.66c2.66-1.51,5.42-3,8.46-3.42a23.39,23.39,0,0,1,6.14.3l23.2,3.2c2.15.3,4.83,1.14,5,3.29a4.86,4.86,0,0,1-.68,2.38l-8.15,16.8c-.91,1.9-1.77,4.07-2.7,6.25-4.26,9.38-9.26,18.38-13.81,27.47-.72,1.75-1.6,3.61-2.51,5.47a11.94,11.94,0,0,1-2.5,3.81c-1.87,1.69-4.57,2-7.07,2.27l-5.22.58q-2.61.3-5.22.63c-6.93,4.15-21.93-.85-23.93,7.15,5,0,11,0,16-.41l5.88-.13c5.89-.12,11.77-.22,17.66-.22A11.2,11.2,0,0,0,78,84.6c4.2-1.6,4.87-7,6.87-10.51,1.78-3.09,3.74-6.06,5.43-9.2l9.53-17.72Q109,29.95,118.48,12.83a4.9,4.9,0,0,0,.87-2.9c-.45-3.13-16.3-4-19.24-4.5l-23.56-4A28.47,28.47,0,0,0,70,.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    className: "cls-6",
    d: "M75.07,43.58c-5.62,8.26-9.62,18.26-18.62,23.26-10,4-33,7-30-5A59.25,59.25,0,0,1,58,23.59a23.17,23.17,0,0,1,4.07-1.28,20.46,20.46,0,0,1,4.34-.47c5,1,11,1,14,7,2,5,0,8-2.66,11.57-.8.92-1.72,1.93-2.72,3.17m9-19.57C75,17.65,65.27,18,56.46,21.58a30.28,30.28,0,0,0-4.87,2.51C39.45,32.84,28.45,42.84,22.78,56.9a27.7,27.7,0,0,0-1.35,4.64,7.85,7.85,0,0,0,2,7.3,13.67,13.67,0,0,0,3,2.26,19,19,0,0,0,3.71,1.57c22.26,6.17,39.26-5.83,46.17-25.51,1-1.69,2-3.15,3-4.63,2.94-4.36,5.42-9,6.23-14.53a6.63,6.63,0,0,0-1.51-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    className: "cls-4",
    d: "M60.91,38.46C49.45,36.84,36.45,49.84,41.45,57.84c7,9,18-10,20.88-17.81a3.84,3.84,0,0,0-1.42-1.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    className: "cls-7",
    d: "M59.69,43.9c-3.23-5.06-9.23-4.06-12.23-.06-3,5-8,11-6,14,6,6,13-6,17.9-11a5.52,5.52,0,0,0,.33-2.9m-3.36,5.3c-2.87,5.63-8.87,8.63-14.87,9.63,3-7,5-18,15-18,2,1,2,4,1.59,5.58a10.35,10.35,0,0,1-1.72,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    className: "cls-7",
    d: "M56,43c-5.5.87-8.5,3.87-10.5,7.87,0,2,1,4,3,4,4-2,8-5,8.18-9.6A2.57,2.57,0,0,0,56,43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    className: "cls-3",
    d: "M53.29,43.76c-5.83.08-7.83,6.08-8.83,11.08,1-2,1-4,2-6,1-1,3-6,5,0,2,4-5,3-7,6,5-2,10-4,10.17-10.43a2.08,2.08,0,0,0-1.34-.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    className: "cls-3",
    d: "M53.45,47.26a3,3,0,0,0-3-1.42c-2,2-4,4-1,6,2,0,0-5,3.7-4.13a1.78,1.78,0,0,0,.28-.45"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement2);
export default __webpack_public_path__ + "static/media/Element2.77139d146b654452d7dac4e2be10d152.svg";
export { ForwardRef as ReactComponent };